import {Injectable} from "@angular/core";
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import { environment } from '../../../environments/environment';

import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class CertificadoService {

  private _Url = environment.UrlPrincipal + '/api/chavecriptografica';
  private _UrlSincronia = environment.UrlPrincipal + '/api/sincronizar';

  constructor(private http: HttpClient) {}

  gerar() {
    let http;
    let dados = null;
    http = this.http.post(this._Url, dados);
    http.map((res) => {
      return res;
    }).catch(this.handleError);
    return http;
  }

  sincronizar() {
    let http;
    http = this.http.get(this._UrlSincronia);
    http.map((res) => {
      return res;
    }).catch(this.handleError);
    return http;
  }

  private handleError(error: Response) {
    return error.json();
  }

}
